import {
  request2,
  request1
} from './request';

// 根据来源渠道获取系统名单分配的招生老师
export function getAssignTeacher(id) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/GetAssignTeacherList',
    method: 'get',
    params: {
      sourseId: id
    }
  })
}

export function getuserinfo() {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/GetUserInfo',
    method: 'get',
  })
}

// 添加学员初始化接口
export function getStudentAddBaseInfo() {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/StudentAddInfo',
    method: 'get'
  })
}

// 添加学员（新）
export function StudentAddNew(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/StudentAddSubmitNew',
    method: 'post',
    data: obj
  })
}

// 编辑学员初始化接口
export function getStudentEditBaseinfo(studentId) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/StudentEditInfo',
    method: 'get',
    params: {
      StudentId: studentId
    }
  })
}

// 编辑学员（新）
export function StudentEditNew(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/StudentEditSubmit',
    method: 'post',
    data: obj
  })
}

// 学员详情（新）
export function getStudentDetailNew(studentId) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/StudentDetailInfo',
    method: 'get',
    params: {
      StudentId: studentId
    }
  })
}

// 获取院校专业（新）
export function getSchoolMajor(id) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/SchoolMajorAdmin/GetSchoolMajorCategoryList',
    method: 'get',
    params: {
      Category: id
    }
  })
}

// 获取毕业院校专业（新）
export function getSchoolMajor1(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/SchoolMajorAdmin/GetSchoolMajorCategoryList',
    method: 'post',
    data: {
      Category: obj.Category,
      Name: obj.Name,
      totalCount: obj.totalCount,
      selectIds: obj.ids,
    }
  })
}

// 总学员列表初始化接口（新）
export function getStudentBaseInfoNew() {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/GetStudentBaseInfo',
    method: 'get'
  })
}

//获取学生列表（新）
export function getStudentNewList(studentIds, obj, pageIndex, pageCount) {
  return request2({
    url: `/api2/TZsbAdminStudentApi/StudentAdminV2/GetStudentAllNewList`,
    method: 'post',
    data: {
      studentIds: studentIds,
      name: obj.studentName,
      sex: obj.sex,
      telPhone: obj.telPhone,
      qqNumber: obj.qqNumber,
      createTimeStart: obj.createTimeStart,
      createTimeEnd: obj.createTimeEnd,
      graduatedSchool: obj.graduatedSchool,
      graduatedMajor: obj.graduatedMajor,
      applySchool: obj.applySchool,
      applyMajor: obj.applyMajor,
      trackTimeStart: obj.trackTimeStart,
      trackTimeEnd: obj.trackTimeEnd,
      sourse: obj.sourse,
      grade: obj.grade,
      purposeCourseCategory: obj.purposeCourseCategory,
      studentIntent: obj.studentIntent,
      studentStates: obj.StudentState,
      handoverId: obj.HandoverId,
      businessId: obj.BusinessId,
      marketingId: obj.MarketingId,
      pageIndex: pageIndex,
      pageSize: pageCount
    }
  })
}

// 下载学员数据初始化接口
export function getStudentDataDownBaseInfo() {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/GetStudentDownInfo',
    method: 'get'
  })
}

//查询可下载的学员数目
export function getStudentDownCount(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/GetStudentDownCount',
    method: 'post',
    data: {
      GraduatedSchool: obj.graduatedSchool,
      GraduatedMajor: obj.graduatedMajor,
      PurposeCourseCategory: obj.purposeCourseCategory,
      BasicEnglish: obj.basicEnglish,
      StudentIntent: obj.studentIntent,
      Sourses: obj.sourses,
      States: obj.states,
      ApplySchool: obj.applySchool,
      ApplyMajor: obj.applyMajor,
      StudentSchoolArea: obj.studentSchoolArea,
      Grade: obj.grade,
      BeginCreateTime: obj.beginCreateTime,
      EndCreateTime: obj.endCreateTime,
      BeginSignUpTime: obj.beginSignUpTime,
      EndSignUpTime: obj.endSignUpTime,
      CourseIds: obj.courseIds,
      IsAllSelectCourse: obj.isAllSelectCourse,
      GradeIds: obj.gradeIds
    }
  })
}

// 下载学员数据
export function getStudentDataDown(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/GetStudentDown',
    method: 'post',
    data: {
      seachs: {
        GraduatedSchool: obj.Seachs.graduatedSchool,
        GraduatedMajor: obj.Seachs.graduatedMajor,
        PurposeCourseCategory: obj.Seachs.purposeCourseCategory,
        BasicEnglish: obj.Seachs.basicEnglish,
        StudentIntent: obj.Seachs.studentIntent,
        Sourses: obj.Seachs.sourses,
        States: obj.Seachs.states,
        ApplySchool: obj.Seachs.applySchool,
        ApplyMajor: obj.Seachs.applyMajor,
        StudentSchoolArea: obj.Seachs.studentSchoolArea,
        Grade: obj.Seachs.grade,
        BeginCreateTime: obj.Seachs.beginCreateTime,
        EndCreateTime: obj.Seachs.endCreateTime,
        BeginSignUpTime: obj.Seachs.beginSignUpTime,
        EndSignUpTime: obj.Seachs.endSignUpTime,
      },
      ids: obj.Ids
    }
  })
}

// 学员资料导入初始化接口
export function getStudentDataImportBaseInfo() {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/GetStudentImportInfo',
    method: 'get'
  })
}

// 导入学员资料项
export function importStudentData(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/StudentImport',
    method: 'post',
    data: {
      ExcelUrl: obj.excelUrl,
      DataTypeIds: obj.ids,
      Sourse: obj.sourse
    }
  })
}

// 列表表头初始化
export function getDataTypeColumns(pageId) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/GetDataTyoeColumns',
    method: 'get',
    params: {
      pageId
    }
  })
}

export function getStudentDataTypeList(data) {
  return request2({
    url: `/api2/TZsbAdminStudentApi/StudentAdminV2/GetStudentDataTypeList`,
    method: 'post',
    data: data
  })
}

// 我的教学学员列表初始化
export function getMyTeachingStudentBaseInfo() {
  return request2({
    url: '/api2/TZsbAdminStudentApi/EducationalStudentAdminV2/GetEducationalStudentBaseInfo',
    method: 'get'
  })
}

/**
 * @MyTeachingStudent 我的教学学员
 */
export function GetStudentsPage(obj, studentIds = []) {
  return request2({
    url: `/api2/TZsbAdminStudentApi/EducationalStudentAdminV2/GetStudentsPage`,
    method: 'post',
    data: {
      studentIds: studentIds,
      studentName: obj.studentName,
      tel: obj.tel,
      businessId: obj.businessId,
      state: obj.state,
      grade: obj.grade,
      openCourseStartTime: obj.openCourseStartTime,
      openCourseEndTime: obj.openCourseEndTime,
      graduatedSchool: obj.graduatedSchool,
      graduatedMajor: obj.graduatedMajor,
      applySchool: obj.applySchool,
      applyMajor: obj.applyMajor,
      studentSchoolAreaId: obj.studentSchoolAreaId,
      pageIndex: obj.pageIndex,
      pageSize: obj.pageSize
    }
  })
}

export function getCategoryList(id) {
  return request2({
    url: `/api2/TZsbAdminStudentApi/Category/GetCatetListByType`,
    method: 'get',
    params: {
      id: id
    }
  })
}


// 学员跟踪记录数目
export function getTrackCount(Ids) {
  return request2({
    url: `/api2/TZsbAdminStudentApi/Track/GetStudentTrackCount`,
    method: 'post',
    data: Ids
  }, false)
}

//获取指定用户已购买的课程:只针对订单状态为[订单完成]的课
export function StudentPayCourses(ids) {
  return request2({
    url: '/api2/TZsbAdminOrderApi/Orders/StudentPayCourses',
    method: 'post',
    data: ids
  }, true)
}

//获取所有产品列表
export function getProductAllList(obj) {
  return request2({
    url: '/api2/TZsbAdminProductApi/Course/GetAllProduct',
    method: 'post',
    data: obj
  }, true)
}

// 批量修改学员所属来源渠道
export function updateStudentClient(data) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/UpdateStudentClient',
    method: 'post',
    data: data
  })
}

// 学员中心通过接口保存token /AdminService/SetTeacherTokenCache
export function setTeacherTokenCache(data) {
  return request2({
    url: '/api2/AdminService/SetTeacherTokenCache',
    method: 'post',
    data: data
  })
}

// 获取指定学员推荐学员数目
export function GetStudentRecommendCount(data) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentReferralRecord/GetStudentRecommendCount',
    method: 'post',
    data: data
  })
}

// 获取指定学员的推荐学员列表
export function GetRecommendStudentList(studentId) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentReferralRecord/GetRecommendStudentList',
    method: 'get',
    params: {
      studentId: studentId
    }
  })
}


// 获取页面关联的按钮集合
export function StuGetTheMenuButtons(pageId) {
  return request2({
    url: `/api2/TZsbAdminStudentApi/ListPageAdmin/GetTheMenuButtons`,
    method: 'get',
    params: {
      pageId:pageId
    }
  })
}